<agpr-take-over-panel
    [id]="id + '.dataSelectTakeoverPanel'"
    class="agpr-dataSelectTakeoverPanel"
    [header]="dialogHeader"
    [overlayContainer]="overlayContainer"
    [hideSlideOverlay]="hideSlideOverlay"
    [animationTrigger]="animationTrigger"
    (visibleChange)="handleVisibleChange($event)"
    [minPanelWidth]="830"
    [maxPanelWidth]="830"
    [responsiveWidth]="true"
>
    <div class="agpr-dataSelectTakeoverPanel-content">
        <div class="agpr-dataSelectTakeoverPanel-column agpr-dataSelectTakeoverPanel-availableItems">
            <div class="agpr-dataSelectTakeoverPanel-columnHeader" [id]="id + '.availableItems.heading'">
                {{ leftColumnHeader | localize }}
            </div>
            <div class="agpr-dataSelectTakeoverPanel-columnBody">
                @if (filterDataType) {
                    <agpr-text-input
                        [id]="id + '.quickFilter'"
                        class="agpr-dataSelectTakeoverPanel-filterInput"
                        icon="fa-regular fa-duotone fa-magnifying-glass"
                        ariaLabel="Common.dialog.dataSelect.filterPlaceholder"
                        placeholder="Common.dialog.dataSelect.filterPlaceholder"
                        [(ngModel)]="filterString"
                        (ngModelChange)="filterItems()"
                        [initialFocus]="true"
                    ></agpr-text-input>
                    <agpr-scroll-panel>
                        <agpr-tree-list
                            class="agpr-dataSelectTakeoverPanel-treeList"
                            [items]="filteredAvailableItems"
                            [(selection)]="selectedItems"
                            (selectionChange)="selectionChange($event)"
                            [hideParentCheckbox]="false"
                            (nodeSelect)="itemSelected($event)"
                            (nodeUnselect)="itemUnselected($event)"
                            (nodeExpand)="nodeExpanded($event)"
                            (nodeCollapse)="nodeCollapsed($event)"
                            [lockMessage]="lockMessage"
                            [templateDataType]="filterDataType"
                            [filterString]="filterString.length > 2 ? [filterString] : []"
                        ></agpr-tree-list>
                    </agpr-scroll-panel>
                }
                @else {
                    <agpr-scroll-panel>
                        <agpr-tree-list
                            class="agpr-dataSelectTakeoverPanel-treeList"
                            [items]="availableItems"
                            [(selection)]="selectedItems"
                            [hideParentCheckbox]="false"
                            [propagateSelectionUp]="propagateSelection"
                            [propagateSelectionDown]="propagateSelection"
                            (selectionChange)="selectionChange($event)"
                            (nodeSelect)="itemSelected($event)"
                            (nodeUnselect)="itemUnselected($event)"
                            (nodeExpand)="nodeExpanded($event)"
                            (nodeCollapse)="nodeCollapsed($event)"
                            [lockMessage]="lockMessage"
                        ></agpr-tree-list>
                    </agpr-scroll-panel>
                }
            </div>
        </div>
        <div class="agpr-dataSelectTakeoverPanel-column agpr-dataSelectTakeoverPanel-selectedItems">
            <div class="agpr-dataSelectTakeoverPanel-columnHeader" [id]="id + '.selectedItems.heading'">
                {{ rightColumnHeader | localize }}
            </div>
            <div class="agpr-dataSelectTakeoverPanel-columnBody">
                <agpr-scroll-panel>
                    <ul class="agpr-dataSelectTakeoverPanel-columnList">
                        @for (type of selectedItemTypes; track type) {
                            <li class="agpr-dataSelectTakeoverPanel-columnListItem">
                                <div class="agpr-dataSelectTakeoverPanel-columnListItem-type">
                                    {{ selectedItemTypesMap.get(type) | localize }}
                                </div>
                                <ul
                                    [id]="'selectedData_' + $index"
                                    class="agpr-dataSelectTakeoverPanel-columnListItem-container"
                                    agprListKeyboardNavigation
                                    listOrientation="horizontal"
                                    [focusOnChild]="true"
                                    [list]="selectedItemsToDisplay"
                                >
                                    @for (item of selectedItemsToDisplay; track item) {
                                        @if (item.type === type || item.data.type === type) {
                                            <li class="agpr-chip">
                                                <span class="agpr-chip-label">
                                                    {{ item.label }}
                                                </span>
                                                <agpr-button
                                                    class="agpr-chip-button"
                                                    [style]="buttonTypes.icon"
                                                    icon="agpr-i-close"
                                                    tooltip="Common.forms.chips.delete"
                                                    tooltipPosition="top"
                                                    (click)="removeItem(item)"
                                                ></agpr-button>
                                            </li>
                                        }
                                    }
                                </ul>
                            </li>
                        }
                    </ul>
                </agpr-scroll-panel>
            </div>
        </div>
    </div>
    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '.dataSelectTakeoverPanel.cancel'"
            label="cancel"
            [style]="buttonTypes.secondary"
            (click)="close()"
        ></agpr-button>
        <agpr-button
            [id]="id + '.dataSelectTakeoverPanel.clear'"
            label="Monitoring.result.reset"
            [style]="buttonTypes.secondary"
            (click)="reset()"
    ></agpr-button>
    </ng-template>
    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '.dataSelectTakeoverPanel.ok'"
            label="Monitoring.result.applySelected"
            [style]="buttonTypes.primary"
            (click)="applySelected()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
